<template>
  <v-app>
    <v-app-bar
      app
      dense
      dark
      color="primary"
    >
      <v-toolbar-title>Configuração Horizontal</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-card elevation="0">
        <v-card-text>
          <v-layout
            wrap
            style="padding: 0; margin: 0 auto"
          >
            <v-flex xs12>
              <v-select
                dense
                outlined
                hide-details
                v-model="data.justify"
                label="Alinhamento"
                :items="[
                  { value: 'fpe-justify-start', text: 'Alinhar à Esquerda' },
                  { value: 'fpe-justify-end', text: 'Alinhar à Direita' },
                  { value: 'fpe-justify-center', text: 'Centralizar' },
                  { value: 'fpe-justify-between', text: 'Espaçar Entre' },
                  { value: 'fpe-justify-around', text: 'Espaçar ao Redor' },
                  { value: 'fpe-justify-evenly', text: 'Espaçar Uniformemente' }
                ]"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'PageRowsConfig',

  props: {
    value: {}
  },

  data () {
    const url = ''
    const data = clone(this.value || {})
    return { data, url }
  },

  watch: {
    data: {
      deep: true,
      handler (data) {
        const vm = this
        if (isEqual(data, vm.value)) return
        vm.$emit('input', clone(data))
      }
    },

    value: {
      deep: true,
      handler (value) {
        const vm = this
        if (isEqual(value, vm.item)) return
        vm.data = clone(value || {})
      }
    }
  }
}

const clone = (source) => JSON.parse(JSON.stringify(source))
const isEqual = (source, target) => JSON.stringify(source) === JSON.stringify(target)

</script>
